import { useEffect } from 'react';

const AdSenseWidget = () => {
  useEffect(() => {
    // Check if the AdSense script is already loaded
    if (!document.querySelector(`script[src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]`)) {
      const script = document.createElement('script');
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6809463573216029";
      script.async = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    }
    // Push ads to the ad queue
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <div className="sidebar-widget" id="google-adsense">
      <div align="center">
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-6809463573216029"
          data-ad-slot="3336111711"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </div>
  );
};

export default AdSenseWidget;
